import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const api = {
  // events / governance
  listEvents: () => http.get("/events").then((r) => r.data),
  getEvent: (id) => http.get(`/events/${id}`).then((r) => r.data),
  approveEvent: (id, body) => http.post(`/events/${id}/approve`, body).then((r) => r.data),
  listPeople: () => http.get("/people").then((r) => r.data),
  createIncident: (body) => http.post("/incidents", body).then((r) => r.data),
  listIncidents: () => http.get("/incidents").then((r) => r.data),
  getIncident: (id) => http.get(`/incidents/${id}`).then((r) => r.data),
  recordDecision: (body) => http.post("/decisions", body).then((r) => r.data),
  createReceipt: ({ event_id, incident_id }) => {
    const params = new URLSearchParams();
    if (event_id) params.set("event_id", event_id);
    if (incident_id) params.set("incident_id", incident_id);
    return http.post(`/receipts?${params.toString()}`).then((r) => r.data);
  },
  listReceipts: () => http.get("/receipts").then((r) => r.data),
  getReceipt: (id) => http.get(`/receipts/${id}`).then((r) => r.data),
  // drivers + sponsor packs
  listDrivers: () => http.get("/drivers").then((r) => r.data),
  getDriver: (id) => http.get(`/drivers/${id}`).then((r) => r.data),
  driverAISummary: (id) => http.post(`/drivers/${id}/ai-summary`).then((r) => r.data),
  createSponsorPack: (body) => http.post(`/sponsor-packs`, body).then((r) => r.data),
  listSponsorPacks: (driver_id) => http.get(`/sponsor-packs${driver_id ? `?driver_id=${driver_id}` : ""}`).then((r) => r.data),
  getSponsorPack: (id) => http.get(`/sponsor-packs/${id}`).then((r) => r.data),
  publicSponsorPack: (token) => http.get(`/share/sponsor/${token}`).then((r) => r.data),
  // sponsors + matches
  listSponsors: () => http.get("/sponsors").then((r) => r.data),
  getSponsor: (id) => http.get(`/sponsors/${id}`).then((r) => r.data),
  suggestMatch: (driver_id, sponsor_id) => http.post(`/matches/suggest`, { driver_id, sponsor_id }).then((r) => r.data),
  createMatch: (body) => http.post(`/matches`, body).then((r) => r.data),
  listMatches: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return http.get(`/matches${q ? `?${q}` : ""}`).then((r) => r.data);
  },
  getMatch: (id) => http.get(`/matches/${id}`).then((r) => r.data),
  publicMatch: (token) => http.get(`/share/match/${token}`).then((r) => r.data),
  // match proposals (inbox)
  listProposals: (params = {}) => {
    const q = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null)
        .map(([k, v]) => [k, String(v)])
    ).toString();
    return http.get(`/match-proposals${q ? `?${q}` : ""}`).then((r) => r.data);
  },
  getProposal: (id) => http.get(`/match-proposals/${id}`).then((r) => r.data),
  createProposal: (body) => http.post(`/match-proposals`, body).then((r) => r.data),
  approveProposal: (id, body) => http.post(`/match-proposals/${id}/approve`, body).then((r) => r.data),
  declineProposal: (id, body) => http.post(`/match-proposals/${id}/decline`, body).then((r) => r.data),
  requestProposalInfo: (id, body) => http.post(`/match-proposals/${id}/request-info`, body).then((r) => r.data),
  // bounded shop / offer service
  listOffers: () => http.get(`/offers`).then((r) => r.data),
  driverOffers: (driver_id) => http.get(`/drivers/${driver_id}/offers`).then((r) => r.data),
  claimOffer: (offer_id, body) => http.post(`/offers/${offer_id}/claim`, body).then((r) => r.data),
  parentApproveClaim: (id, body) => http.post(`/offer-claims/${id}/parent-approve`, body).then((r) => r.data),
  officerApproveClaim: (id, body) => http.post(`/offer-claims/${id}/officer-approve`, body).then((r) => r.data),
  declineClaim: (id, body) => http.post(`/offer-claims/${id}/decline`, body).then((r) => r.data),
  listClaims: (driver_id) => http.get(`/offer-claims${driver_id ? `?driver_id=${driver_id}` : ""}`).then((r) => r.data),
  getClaim: (id) => http.get(`/offer-claims/${id}`).then((r) => r.data),
  katlasStatus: () => http.get(`/katlas/status`).then((r) => r.data),
  seed: (force = false) => http.post(`/seed${force ? "?force=true" : ""}`).then((r) => r.data),
};
